module.exports = __webpack_public_path__ + "static/img/tx3-b.50bd71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/tx3-b.png
// module id = ojQ/
// module chunks = 1